export default {
  toasts: {
    auth_token_invalid: 'Nieprawidłowy token autoryzacji',
    host_access_refused:
      'Ten adres należy do partnera, do którego to konto nie należy. Zaloguj się pod własnym adresem.',
  },
};
